export default __webpack_public_path__ + "static/media/nth.6acc9522.jpg";